import {
  Box,
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  TextField,
  Button,
  Chip,
  useTheme,
  useMediaQuery
} from "@mui/material";
import { useState, useMemo } from "react";
import { generarTicketVenta } from "./generarTicketVenta";
import { useSubscriptionStatus } from "../useSubscriptionStatus";
import {cloudSync} from '../../utils/cloudStorage'
import Alert from '@mui/material/Alert';
export default function HistorialVentas({ state }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { status } = useSubscriptionStatus('fastfood_pos_v1');
  const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const hoy = new Date().toLocaleDateString('en-CA', {
    timeZone: userTZ
  });

  const [inicio, setInicio] = useState(hoy);
  const [fin, setFin] = useState(hoy);

  const [syncing, setSyncing] = useState(false);
  const [done, setDone] = useState(false);
  const [syncError, setSyncError] = useState(null);

  const handleSync = async () => {
    setSyncing(true);
    setDone(false);
    
    setSyncError(null);
    try {
      await cloudSync.pushAll();
      setDone(true);
      setTimeout(() => setDone(false), 3000);
    } catch (err) {
      setSyncError(err.response?.data?.message || 'No se pudo guardar. Tus cambios locales se conservan.');
    } finally { setSyncing(false); }
  };

  const ventasVisibles = useMemo(() => {
    return state.ventas.filter(v => {
      const d = new Date(v.fecha);
      return (
        d >= new Date(`${inicio}T00:00:00`) &&
        d <= new Date(`${fin}T23:59:59`)
      );
    });
  }, [inicio, fin, state.ventas]);

  return (
    <Paper sx={{ p: 3 }}>
      {syncError && <Alert severity="error">{syncError}</Alert>}
      <Typography
        variant={isMobile ? "h5" : "h4"}
        fontWeight="bold"
        gutterBottom
      >
        Historial de Ventas
      </Typography>

      {/* FILTROS */}
      <Stack
        direction={isMobile ? "column" : "row"}
        spacing={2}
        mb={3}
      >
        <TextField
          label="Desde"
          type="date"
          value={inicio}
          onChange={e => setInicio(e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth={isMobile}
        />
        <TextField
          label="Hasta"
          type="date"
          value={fin}
          onChange={e => setFin(e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth={isMobile}
        />
      </Stack>

      {/* TABLA */}
      <Box sx={{ overflowX: isMobile ? "auto" : "visible" }}>
        <Table
          size="small"
          sx={{ minWidth: isMobile ? 600 : "auto" }}
        >
          <TableHead>
            <TableRow sx={{ bgcolor: "#f5f5f5" }}>
              <TableCell>Fecha</TableCell>
              <TableCell>Ticket</TableCell>

              {!isMobile && (
                <TableCell align="right">Total</TableCell>
              )}

              {!isMobile && (
                <TableCell>Pago</TableCell>
              )}

              <TableCell align="center">Estado</TableCell>
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {ventasVisibles.map(v => (
              <TableRow
                key={v.id}
                sx={{ opacity: v.anulado ? 0.4 : 1 }}
              >
                <TableCell>
                  {new Date(v.fecha).toLocaleString()}
                </TableCell>

                <TableCell>
                  <strong>
                    {v.id.substring(0, 6).toUpperCase()}
                  </strong>
                </TableCell>

                {!isMobile && (
                  <TableCell align="right">
                    {state.config.moneda}{" "}
                    {v.total.toFixed(2)}
                  </TableCell>
                )}

                {!isMobile && (
                  <TableCell>{v.metodoPago}</TableCell>
                )}

                <TableCell align="center">
                  {v.anulado ? (
                    <Chip
                      label="ANULADO"
                      color="error"
                      size="small"
                    />
                  ) : (
                    <Chip
                      label="OK"
                      color="success"
                      size="small"
                    />
                  )}
                </TableCell>

                <TableCell align="center">
                  <Stack
                    direction={isMobile ? "column" : "row"}
                    spacing={1}
                    justifyContent="center"
                  >
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() =>
                        generarTicketVenta(v, state.config)
                      }
                    >
                      PDF
                    </Button>

                    {!v.anulado && (
                      <Button
                        size="small"
                        color="error"
                        onClick={async () =>{
                          await state.anularVenta(v.id);
                          handleSync();
                        }
                        }
                        disabled={status != 'ACTIVE' && status != 'EXPIRING'}
                      >
                        Anular
                      </Button>
                    )}
                  </Stack>
                </TableCell>
              </TableRow>
            ))}

            {ventasVisibles.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={isMobile ? 4 : 6}
                  align="center"
                >
                  No hay ventas en este rango
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
    </Paper>
  );
}
